module.exports = __webpack_public_path__ + "static/media/taxiselectricos.58e85dee.png";